import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'

import styles from './widgets.module.sass'
import { renderContactCard } from './utils'

const InjuredWidget = (props) => {
	const { data } = props
	const { process } = data
	const { i18n } = useGlobal()

	return (
		<ExpandableWidget
			className={styles['aside-widget']}
			titleAppearance='aside-widget'
			arrowPosition='right'
			heading='h5'
			icon='user'
			title={i18n`Injured`}
			collapsedLabel={process?.injured?.name}
			expanded={!!process?.injured}
			expandable={!!process?.injured}
			borderRadius
			margins={['small', '', '']}
			paddings={['xsmall', 'xsmall', 'xsmall']}
		>
			<HStack
				className={styles['entry']}
				columns={[1, 3]}
				gap='xsmall'
				justify='space-between'
			>
				<small>
					<strong className='capitalize'>{i18n`Insured`}</strong>
				</small>
				<small>{process?.insurancePolicy?.insured?.name}</small>
			</HStack>
			{renderContactCard(process?.injured || {}, i18n)}
		</ExpandableWidget>
	)
}

export default InjuredWidget
